import { useSelector } from 'react-redux'

import { useOfferedRecipes } from 'hooks/menu-recipes/useOfferedRecipes'
import { Recipe, RecipeCoreId } from 'reducers/menu-recipes/recipes'
import { getBasketRecipes } from 'selectors/basket'
import { locationQuery } from 'selectors/routing'

/**
 * @deprecated This hook is deprecated and will be removed after the refactor of addRecipe logic.
 * Please use `useIsRecipeInStock` instead for checking stock status.
 * @see useIsRecipeInStock
 */
export const useInStockRecipeCoreIds = (): Set<RecipeCoreId> => {
  const recipes = useOfferedRecipes()
  const availableRecipes = recipes
    ?.filter((recipe: Recipe) => recipe.isAvailable)
    .map((recipe: Recipe) => recipe.coreId)

  const basketRecipes = useSelector(getBasketRecipes)
  const basketRecipeIds: RecipeCoreId[] = basketRecipes ? basketRecipes.keySeq().toArray() : []

  const query = useSelector(locationQuery)
  const isAdmin = query && query['preview[menu_id]']

  const allRecipeCoreIds = recipes.map((recipe: Recipe) => recipe.coreId)

  const inStockRecipeCoreIds = isAdmin
    ? allRecipeCoreIds
    : [...availableRecipes, ...basketRecipeIds]

  return new Set(inStockRecipeCoreIds)
}
